import { useEffect, useState } from 'react'
import styled from 'styled-components'
import {
  AlertStatusCard,
  ChartWithZoomable,
  PredictionChartWrapper,
  RecommendationCard,
} from '../../../components'
import useViewport from '../../../hooks/useViewport'
import { useChartZoomable } from '../../../hooks'
import AlreadyDrinkSVG from '../../../assets/chart/already-drink.svg?react'
import { getDDMM, getHHmm } from '../../../utils/dateConversion'
import { useTranslation } from "react-i18next"

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 24px;
`

const RecommendationContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: flex-start;
  flex-direction: column;
  margin-top: 8px;
  gap: 8px;
  padding: 16px;
  border: 1px solid #d6d7db;
  border-radius: 8px;
`

const RecommendationCardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 16px;
  gap: 8px;
`

const PredictionDashboard = ({
  predictionResult,
  userShifts,
  sleepTime,
  ingestedCaffeine,
  bacLevels,
}) => {
  const [graphSize, setGraphSize] = useState(720)
  const [seeTotalPeriod, setSeeTotalPeriod] = useState(false)
  const { width } = useViewport()
  const { getEightHoursBackAndTwentyHoursFowardData } = useChartZoomable({
    seeTotalPeriod,
  })
  const { t } = useTranslation('common')

  const dateNow = new Date().getTime()

  const predictionIndexNow = predictionResult.findIndex(
    item => item.timestamp > dateNow,
  )

  useEffect(() => {
    if (width <= 768) {
      setGraphSize(700)
      return
    }

    if (width > 768 && width <= 850) {
      setGraphSize(720)
      return
    }

    if (width >= 850 && width <= 1440) {
      setGraphSize(850)
      return
    }

    if (width > 1440) {
      setGraphSize(1024)
      return
    }

    setGraphSize(920)
    return
  }, [width])

  const haveCaffeineLastEightHours = ingestedCaffeine?.filter(intake => {
    return Date.now() - intake?.caffeineHour <= 1000 * 60 * 60 * 8
  })

  const getCaffeineIntake = () => {
    return haveCaffeineLastEightHours?.map(({ caffeineHour, index }) => {
      const caffeineTaken = new Date(caffeineHour)
      return (
        <div style={{ display: 'flex', gap: 8 }} key={caffeineHour + index}>
          <RecommendationCard
            icon={<AlreadyDrinkSVG />}
            reccomendation={`${getHHmm({
              hours: caffeineTaken.getHours(),
              minutes: caffeineTaken.getMinutes(),
            })} ${t('user_dashboard.prediction.from')} ${getDDMM({ date: caffeineTaken })}`}
          />
        </div>
      )
    })
  }

  return (
    <Container>
      <AlertStatusCard alertStatus={predictionResult[predictionIndexNow || 0]?.prediction} />

      <ChartWithZoomable
        seeTotalPeriod={seeTotalPeriod}
        onChange={() => setSeeTotalPeriod(!seeTotalPeriod)}
      >
        <PredictionChartWrapper
          predictionResult={getEightHoursBackAndTwentyHoursFowardData({
            action: predictionResult,
          })}
          userShifts={getEightHoursBackAndTwentyHoursFowardData({
            action: userShifts,
          })}
          sleepTime={getEightHoursBackAndTwentyHoursFowardData({
            action: sleepTime,
          })}
          graphSize={graphSize}
          ingestedCaffeine={getEightHoursBackAndTwentyHoursFowardData({
            action: ingestedCaffeine,
          })}
          bacLevels={bacLevels}
        />
      </ChartWithZoomable>

      {haveCaffeineLastEightHours?.length > 0 && (
        <RecommendationContainer>
          <span style={{ fontSize: 20, fontWeight: 600 }}>
            {t('user_dashboard.prediction.caffeine_ingested')}
          </span>
          <RecommendationCardContainer width={width}>
            {getCaffeineIntake()}
          </RecommendationCardContainer>
        </RecommendationContainer>
      )}

    </Container>
  )
}

export default PredictionDashboard
